import React, { PropTypes } from "react";
import ReactDOM from "react-dom";
import { getTimeConfig, formatOfZero, formatDate } from "../util/index";

function copyTime(target, source) {
  if (source) {
    target.setHourOfDay(source.getHourOfDay());
    target.setMinutes(source.getMinutes());
    target.setSeconds(source.getSeconds());
  }
  return target;
}

const DateInput = React.createClass({
  propTypes: {
    prefixCls: PropTypes.string,
    timePicker: PropTypes.object,
    disabledTime: PropTypes.any,
    formatter: PropTypes.object,
    locale: PropTypes.object,
    gregorianCalendarLocale: PropTypes.object,
    disabledDate: PropTypes.func,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    placeholder: PropTypes.string,
    onSelect: PropTypes.func,
    selectedValue: PropTypes.object,
    formatWithZero: PropTypes.boolean
  },

  getInitialState() {
    const { formatWithZero = true, selectedValue, formatter } = this.props;
    return {
      str:
        (selectedValue &&
          formatOfZero(formatter.format(selectedValue), formatWithZero)) ||
        "", // feat: formatOfZero 增加是否显示数字前的0的处理。这里不好改node_module的方法，统一增加formatOfZero方法处理
      invalid: false
    };
  },

  componentWillReceiveProps(nextProps) {
    // when popup show, click body will call this, bug!
    const { formatWithZero = true, selectedValue, formatter } = nextProps;
    this.setState({
      str:
        (selectedValue &&
          formatOfZero(formatter.format(selectedValue), formatWithZero)) ||
        "",
      invalid: false
    });
  },

  onInputKeyDown(event) {
    if (event.keyCode === 13) {
      // !showTime 情况下 回车选择日期功能
      if (this.props.showTime) return;
      const str = event.target.value;
      let value;
      const {
        disabledDate,
        formatter,
        gregorianCalendarLocale,
        onEnter
      } = this.props;
      if (str) {
        const enterFunc = v => typeof onEnter === "function" && onEnter(v);
        try {
          value = copyTime(
            formatter.parse(str, {
              locale: gregorianCalendarLocale,
              obeyCount: true
            }),
            this.props.selectedValue
          );
        } catch (ex) {
          enterFunc(null);
          return;
        }
        if (value && (!disabledDate || !disabledDate(value))) {
          enterFunc(value);
        } else {
          enterFunc(null);
        }
      } else {
        enterFunc(null);
      }
    }
  },

  onInputChange(event) {
    let str = event.target.value;
    this.setState({
      str
    });
    let value;
    const {
      disabledDate,
      format,
      formatter,
      gregorianCalendarLocale,
      showTime,
      formatWithZero = true,
      onChange
    } = this.props;
    if (str) {
      // 显示时间的情况 format一般为 YYYY-MM-DD HH:mm:ss(或者HH:mm) 但是这里的str只有YYYY-MM-DD
      // showTime && str 匹配 YYY-MM-DD的时候,转成同format匹配的数据  fix: 下面formatter.parse转换str失败的问题
      if (showTime && /^\d{4}\-\d{2}\-\d{2}$/.test(str)) {
        str = formatDate(new Date(str), format, formatWithZero);
      }
      try {
        value = copyTime(
          formatter.parse(str, {
            locale: gregorianCalendarLocale,
            obeyCount: true
          }),
          this.props.selectedValue
        );
      } catch (ex) {
        this.setState({
          invalid: true
        });
        return;
      }
      if (value && (!disabledDate || !disabledDate(value))) {
        const originalValue = this.props.selectedValue;
        if (originalValue && value) {
          if (originalValue.getTime() !== value.getTime()) {
            onChange(value);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else {
        this.setState({
          invalid: true
        });
        return;
      }
    } else {
      onChange(null);
    }
    this.setState({
      invalid: false
    });
  },

  onClear() {
    this.setState({
      str: ""
    });
    this.props.onClear(null);
  },

  getRootDOMNode() {
    return ReactDOM.findDOMNode(this);
  },
  focus() {
    this.refs.dateInput.focus();
  },

  hasPlaceHolder() {
    const input = document.createElement("input");
    return "placeholder" in input;
  },

  render() {
    const props = this.props;
    let { invalid, str } = this.state;
    const {
      selectedValue,
      locale,
      prefixCls,
      placeholder,
      onChange,
      timePicker,
      disabledTime,
      formatWithZero = true,
      gregorianCalendarLocale
    } = props;
    const invalidClass = invalid ? `${prefixCls}-input-invalid` : "";
    const disabledTimeConfig =
      disabledTime && timePicker
        ? getTimeConfig(selectedValue, disabledTime)
        : null;
    if (timePicker && str) {
      if (!formatWithZero) {
        // 增加格式化不带0的时候。输入框截取的数字处理
        str = str.slice(0, str.indexOf(" "));
      } else {
        str = str.slice(0, 10);
      }
    }
    const hasPlaceHolder = this.hasPlaceHolder();
    return (
      <div className={`${prefixCls}-input-wrap`}>
        <div className={`${prefixCls}-time-picker-wrap`}>
          {timePicker
            ? React.cloneElement(timePicker, {
                showClear: false,
                allowEmpty: false,
                getPopupContainer: this.getRootDOMNode,
                gregorianCalendarLocale,
                value: selectedValue,
                onChange,
                ...disabledTimeConfig
              })
            : null}
        </div>
        <div className={`${prefixCls}-date-input-wrap`}>
          {!hasPlaceHolder && str === "" && (
            <span className="ant-calendar-range-picker-placeholder-ie9">
              {placeholder}
            </span>
          )}
          <input
            ecId={`${this.props.ecId}_input@144am8`}
            ref="dateInput"
            className={`${prefixCls}-input  ${invalidClass}`}
            value={str}
            placeholder={placeholder}
            onChange={this.onInputChange}
            onKeyDown={this.onInputKeyDown}
          />
        </div>
        {props.showClear ? (
          <a
            ecId={`${this.props.ecId}_a@bhee5d`}
            className={`${prefixCls}-clear-btn`}
            role="button"
            title={locale.clear}
            onClick={this.onClear}
          />
        ) : null}
      </div>
    );
  }
});

export default DateInput;



// WEBPACK FOOTER //
// ./_rc-calendar-5.6.2/src/date/DateInput.js